import { render, staticRenderFns } from "./Colours.vue?vue&type=template&id=7f9bd2f9"
import script from "./Colours.vue?vue&type=script&lang=js"
export * from "./Colours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports